import React, { useState } from "react";
import { useRouter } from "next/router";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ConfirmDialog, Loading } from "src/apps/commons/dataDisplays";
import useApiAlert from "src/hooks/useApiAlert";
import useHttpErrorHandler from "src/hooks/useHttpErrorHandler";
import * as Api from "../api";
import { useGet } from "../hooks";
import { IUserProductSaveReqContainer } from "../types";
import { paths } from "../utils";
import Edit from "./Edit";

const styles = makeStyles(theme => ({
  table: {
    marginTop: theme.spacing(2),
    height: "calc(100vh - 116px)",
    backgroundColor: theme.palette.background.default
  }
}));

interface Props {
  id: UserProductId;
}

const EditContainers: React.FC<Props> = props => {
  const { id } = props;
  const classes = styles();
  const router = useRouter();
  const { setMessage } = useApiAlert();
  const { handleError } = useHttpErrorHandler();

  const { fetching, data } = useGet(id);

  const [saving, setSaving] = useState(false);
  const [confirmDialogState, setConfirmDialogState] = useState<{
    open: boolean;
    message?: string;
    onConfirm?: () => void;
  }>({ open: false });

  const handleSubmit = (req: IUserProductSaveReqContainer) => {
    setConfirmDialogState({
      open: true,
      // message: JSON.stringify(req, null, 2),
      message:
        `สินค้า: ${data?.product?.productName ?? "ไม่ระบุชื่อ"}\n` +
        `ลูกค้า: ${data?.product?.user?.displayName ?? "ไม่ระบุชื่อ"}`,
      onConfirm: async () => {
        try {
          setSaving(true);
          await Api.updateUserProduct(id, req);
          await router.push(paths.index);
          setMessage("success", `บันทึกข้อมูล User Product สำเร็จ`);
        } catch (e) {
          handleError(e);
          setSaving(false);
          handleCloseDialog();
        }
      }
    });
  };

  const handleCloseDialog = () => {
    setConfirmDialogState({ open: false, onConfirm: undefined });
  };

  return !fetching && data ? (
    <>
      <Edit data={data} submitForm={handleSubmit} />
      <ConfirmDialog
        title="ยืนยันการบันทึกข้อมูล User Product"
        description={confirmDialogState.message}
        open={confirmDialogState.open}
        onClose={handleCloseDialog}
        onConfirm={confirmDialogState.onConfirm}
        confirming={saving}
      />
    </>
  ) : (
    <Paper className={classes.table}>
      <Loading key="loading" />
    </Paper>
  );
};

export default EditContainers;
